import moment from 'moment';
import { ActiveWeeklyMenu } from '../services/deliverer/types';

export const getWeeklyMenuKeyForDate = (
  date: moment.MomentInput,
  activeWeeklyMenus: ActiveWeeklyMenu[]
): string | undefined =>
  activeWeeklyMenus.find((menu) =>
    moment(date).isBetween(menu.startDate, menu.finalDate, 'day', '[]')
  )?.weeklyMenuKey;
